import React from "react"
import { Navigation } from "@kit/design/navigation"
import { Icon } from "@kit/design/icon"
import { useCurrentUser } from "hooks/use-current-user"
import { useFeature } from "hooks/use-feature"
import { SIGNALS_STATE } from "pages/signals/constants"

export function SignalsNavItem({ renderLink, trackClick }) {
  const { enabled: featureEnabled } = useFeature.static(
    "signals_in_app_expansion"
  )
  const { signalsAccessLevel } = useCurrentUser()
  const state = signalsAccessLevel?.state
  const signalsEnabled = state === SIGNALS_STATE.ENABLED

  if (!featureEnabled) return null

  let badge
  let trailing
  switch (state) {
    case SIGNALS_STATE.NON_PRO:
    case SIGNALS_STATE.PRO_TRIAL:
      badge = "pro"
      break
    case SIGNALS_STATE.ENRICHING:
    case SIGNALS_STATE.IN_ENRICHMENT_QUEUE:
      trailing = <Icon name="refresh" size="xs" />
      break
    case SIGNALS_STATE.ENABLED:
      trailing = <Icon name="arrow-up-right" size="xs" />
      break
  }

  return (
    <Navigation.Item
      leading="signals"
      label="Subscriber Signals"
      tooltip="See your subscribers' demographics and social influence"
      badge={badge}
      trailing={trailing}
      pathPrefix={signalsEnabled ? undefined : "/signals"}
      render={
        signalsEnabled ? (
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a
            href="https://signals.kit.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackClick("Subscriber Signals", undefined, undefined, {
              signals_state: state
            })}
          />
        ) : (
          renderLink(
            "/signals",
            trackClick("Subscriber Signals", undefined, undefined, {
              signals_state: state
            })
          )
        )
      }
    />
  )
}
